module.exports = __webpack_public_path__ + "assets/12b28672450c41e85993f03661610902.mp3";